import {BottomDrawer} from "~/components/BottomDrawer";
import {useScaffoldPreviewNavigation} from "~/workspaceConfig/scaffoldTest/scaffoldPreviewNavigationContext";
import {ScaffoldPreviewContainedDrawer} from "~/workspaceConfig/scaffoldTest/scaffoldPreviewContainedDrawer";
import {WorkspaceCreateFormGrid} from "~/components/pageScaffolds/workspacePageScaffold/bottomNav/workspaceCreateFormGrid";
import type {WorkspaceMobileBottomCreateItem} from "@vesta/vos-types/modules/workspaceLevel/workspaceUiConfigs/domain/WorkspaceMobileBottomCreateItem";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export function BottomNavMobileCreateDrawer({
    opened,
    onClose,
    workspaceId,
    items,
    onBeforeNavigate,
}: {
    opened: boolean;
    onClose: () => void;
    workspaceId: Uuid;
    items: readonly WorkspaceMobileBottomCreateItem[];
    onBeforeNavigate?: () => void;
}) {
    const preview = useScaffoldPreviewNavigation();
    const handleOpenChange = (value: boolean | ((previous: boolean) => boolean)) => {
        const next = typeof value === "function" ? value(opened) : value;
        if (next === false) {
            onClose();
        }
    };
    const createGrid = (
            <WorkspaceCreateFormGrid
                workspaceId={workspaceId}
                items={items}
                onNavigate={onClose}
                onBeforeNavigate={onBeforeNavigate}
                variant="drawer"
            />
    );

    if (preview !== null) {
        return (
            <ScaffoldPreviewContainedDrawer
                open={opened}
                setOpen={handleOpenChange}
                title="Create"
                headerBottomBorder={true}
            >
                {createGrid}
            </ScaffoldPreviewContainedDrawer>
        );
    }

    return (
        <BottomDrawer
            open={opened}
            setOpen={handleOpenChange}
            title="Create"
            fitContentOnOpen
            headerBottomBorder
        >
            {createGrid}
        </BottomDrawer>
    );
}
